import type {
  PartnerAdminTopBanner,
  PostApiV1ThreeLetterCodePartnerAdminsTopBannersBody,
} from '@fukuri-admins/apis/client/gen/model';
import { fileToUrlByBase64 } from '@fukuri-admins/utils/common';
import { CreateTopBannerFormFieldValues } from '../schema';

type IGenerateRequest = (args: {
  /** フォームの入力値 */
  formValues: CreateTopBannerFormFieldValues;
  /** 既存のトップバナー一覧（sortOrder計算用） */
  topBanners: PartnerAdminTopBanner[];
}) => Promise<PostApiV1ThreeLetterCodePartnerAdminsTopBannersBody>;

/**
 * フォームの値からAPIリクエストボディを生成する
 *
 * @param args.formValues - フォームの入力値
 * @param args.topBanners - 既存のトップバナー一覧（sortOrder計算用）
 * @returns APIリクエストボディ
 */
export const generateRequest: IGenerateRequest = async ({ formValues, topBanners }) => {
  const { title, transitionUrl, status, image, groupId, restrictedToApp, targetUserType } =
    formValues;

  // FileオブジェクトをBase64に変換
  const imageBase64 = await fileToUrlByBase64(image);

  // 新規作成時のsortOrderは最大値+1
  const sortOrder =
    topBanners.length > 0 ? Math.max(...topBanners.map(banner => banner.sort_order)) + 1 : 1;

  return {
    top_banner: {
      title,
      transition_url: transitionUrl,
      restricted_to_app: restrictedToApp === 'true',
      status: Number(status),
      sort_order: sortOrder,
      image: imageBase64,
      group_id: groupId ? Number(groupId) : undefined,
      target_user_type: targetUserType,
    },
  };
};
